import React from 'react'

const Messages = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" color='gray' width={props.width} height={props.height} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-message-square"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
  )
}

export default Messages